import './App.css';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { TextMeTheAppConnected } from './components/core/components/TextMeTheApp';
import { UserDataResponse } from './models/plaid';
import { AuthState, UtmData } from './store/AppState';
import { setToggleCallbackToTrackToggle } from './utils/ada';
import { numMembersText } from './utils/configuration';

interface Props extends RouteComponentProps<{}> {
  authState: AuthState;
  userData: UserDataResponse;
  utmData: UtmData;
}

const mapStateToProps = (state) => {
  const { authState, userData, utmData } = state;
  return { authState, userData, utmData };
};

class App extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.props.history.listen(() => {
      // eslint-disable-next-line no-undef
      analytics.page();
    });
  }

  componentDidMount() {
    setToggleCallbackToTrackToggle();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Text me the app</title>
          <meta
            name="description"
            content={`Get up to $500 whenever you need it. Build your credit while saving. No credit check. No interest. Access in 60 seconds. Join over ${numMembersText} members.`}
          />
          <meta
            name="keywords"
            content="Overdraft Protection Solution, Cash Advance, Personal Loan, No Credit Check"
          />
          {/* This script will load a small question mark button on the bottom right corner of your page, clicking
          on which will toggle the Ada Web Chat in and out of view. We load this script here instead of index.html 
          so that it can be overridden on some pages where we don't want the button to appear.
          Refer to https://adasupport.github.io/documentation/#embed2 for more context.
          */}
          <script id="__ada" data-handle="brigit" src="https://static.ada.support/embed2.js" />
        </Helmet>
        <Switch>
          <Route path="/" component={TextMeTheAppConnected} />
        </Switch>
      </>
    );
  }
}

export const ConnectedApp = withRouter(connect(mapStateToProps)(App));
